import React from 'react';
import { useModalsContext } from '/src/providers';
import { Modal } from '/src/components';

const NotificationPreferencesReadMore = ({ html }) => {
    const { hideModal } = useModalsContext();

    return (
        <Modal toggle={hideModal}>
            <div dangerouslySetInnerHTML={{ __html: html }} />
        </Modal>
    );
};

export default NotificationPreferencesReadMore;
